import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import R from 'ramda'

export const initialState = {
  isLoading: true,
  filters: {},
  items: [],
  pagination: {}
}

const items = handleActions({
  FETCH_JOBS_FULFILLED: (state, action) => action.payload.items
}, [])

const pagination = handleActions({
  FETCH_JOBS_FULFILLED: (state, action) => ({
    ...state,
    ...(action.payload.pagination || {})
  }),
  FETCH_JOBS_PENDING: (state, action) => ({
    ...state,
    ...R.pick(['page', 'pageCount', 'pageSize'], action.meta || {})
  })
}, initialState.pagination)

const filters = handleActions({
  FETCH_JOBS_PENDING: (state, action) => (action.meta ? {
    ...state,
    ...R.pick(['filters'], action.meta).filters
  } : {})
}, initialState.filters)

const isLoading = handleActions({
  FETCH_JOBS_PENDING: () => true,
  FETCH_JOBS_FULFILLED: () => false,
  FETCH_JOBS_REJECTED: () => false
}, initialState.isLoading)

export default combineReducers({
  items,
  pagination,
  filters,
  isLoading
})



// WEBPACK FOOTER //
// ./src/reducers/jobs.js